import { useContext } from 'react';
import { AuthContext } from './context';

export const useAuthService = () => {
  const authService = useContext(AuthContext);

  if (!authService) {
    throw new Error('useAuthService must be used within an AuthProvider');
  }
  return authService;
};
